import { ComponentPropsWithoutRef, ForwardedRef, forwardRef, useContext, useEffect } from 'react';
import { TableContext, TableRowContext } from 'components/table/TableContext';
import { twMerge } from 'tailwind-merge';

interface TableRowProps extends ComponentPropsWithoutRef<'tr'> {}

const TableRow = forwardRef((props: TableRowProps, ref: ForwardedRef<HTMLTableRowElement>) => {
    const { table } = useContext(TableContext);
    const { row } = useContext(TableRowContext);
    const { className = '', ...rest } = props;
    const rowId = row.id;
    const tableState = table.getState();
    const isRowPending = table.options.enableRowPending && tableState.rowPending.includes(rowId);
    const isRowReplacment =
        table.options.enableRowReplacement &&
        tableState?.rowReplacement?.find(r => r.rowId === rowId);

    useEffect(() => {
        return () => {
            if (table.options.enableRowPending) {
                table.updateRowPending();
            }
            if (table.options.enableRowReplacement) {
                table.updateRowReplacement();
            }
        };
    }, [isRowPending, isRowReplacment, table]);

    return (
        <tr
            ref={ref}
            className={twMerge(
                `group`,
                isRowPending &&
                    'bg-gray-25 pointer-events-none select-none [&>td]:bg-transparent [&>td]:opacity-[0.31]',
                (!!table.options.meta?.to || !!table.options.meta?.onRowClick) &&
                    '[&_td]:focus-within:bg-gray-100 [&_td]:hover:cursor-pointer [&_td]:hover:bg-gray-50',
                className,
                table.options.meta?.rowClassName,
                row?.getIsSelected?.() && table.options.meta?.selectedRowClassName,
            )}
            {...rest}
        />
    );
});

export { TableRow };
export type { TableRowProps };
